import { AnnotationModel, SampleModel, TaskModel } from "core/models";
import { StyleAssetStatusTypes } from "core/models/StyleAssetFilterModel";
import { ERROR_MESSAGES, ERROR_TYPES, Exceptions } from "utils/constants";
import { getToken, parseValue } from "utils/helper";
import { logger } from "utils/logger";

export const getStyle = async (id) => {
  const url = `${process.env.REACT_APP_API_URL}/style/${id}`;
  const formData = JSON.stringify({});

  logger.log(" GETTING SAMPLE DATA: ", formData);
  return fetch(url, {
    headers: {
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (data && data.baseStyle && data.baseStyle.length) {
        var style = { ...data.baseStyle[0] };
        var items = data.assets
          .filter((tmpItem) => tmpItem.assignedSequence.length)
          .map((item, idx) => {
            var newItem = item;
            return newItem;
          });
        style.assets = items;
        return style;
      } else {
        const error = new Error(ERROR_MESSAGES[ERROR_TYPES.NOT_FOUND]);
        error.type = ERROR_TYPES.NOT_FOUND;
        throw error;
        // throw "No style Found";
      }
    })
    .catch((err) => {
      logger.error("ERROR getting style", err);
      throw err;
    });
};

export const getSelects = async (id) => {
  const url = `${process.env.REACT_APP_API_URL}/approval/selects`;
  const formData = JSON.stringify({});

  logger.log(" GETTING STYLE DATA: ", formData);
  return fetch(url, {
    headers: {
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      var items = data.Items.map((item, idx) => {
        var newItem = {};
        newItem = new SampleModel(item);
        newItem.id = newItem.ssSort;
        newItem.dept = item.department;
        newItem.styleNumber = item.ssSort;
        return newItem;
      });
      return items;
    })
    .catch((err) => {
      logger.error("ERROR getting style", err);
      throw err;
    });
};

export const getStyleCaptures = async (criteria) => {
  const { sessionCode, styleNumber } = criteria;

  const url = `${process.env.REACT_APP_API_URL}/approval/selects/${sessionCode}/${styleNumber}`;
  const formData = JSON.stringify({});

  logger.log(" GETTING STYLE DATA: ", formData);
  return fetch(url, {
    headers: {
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      var items = data.Items.map((item, idx) => {
        var newItem = {};
        newItem = item;
        newItem.id = newItem.actionSort;
        // newItem.styleNumber = item.ssSort;
        // newItem.dept = item.department;
        // newItem.id = newItem.styleNumber;
        return newItem;
      });
      return items;
    })
    .catch((err) => {
      logger.error("ERROR getting style captures", err);
      throw err;
    });
};

export const updateCapture = async (capture, token) => {
  logger.log("UPDATING CAPTURE: ", capture);
  // /approval/selects/captures/{part}/{sort}
  const url = `${process.env.REACT_APP_API_URL}/approval/selects/captures/${capture.actionPart}/${capture.actionSort}`;

  const tmpCapture = { ...capture };

  // remove the action part and sort
  delete tmpCapture.actionPart;
  delete tmpCapture.actionSort;

  const formData = JSON.stringify(tmpCapture);

  logger.log(" UPDATING Capture DATA: ", formData);
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      onset: getToken(),
    },
    method: "PUT",
    body: formData,
  })
    .then((response) => {
      logger.log(response);
      if (response) {
        return response.json();
      }
      throw new Error("Error updating captures");
    })
    .then((data) => {
      if (data.__type && data.__type === Exceptions.SERIALISATION) {
        throw new Error("Error updating captures");
      }
      logger.log(data);
      return true;
      //return imgUploadUrl;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const updateSessionStyle = async (style, token) => {
  logger.log("UPDATING CAPTURE: ", style);
  // /approval/selects/captures/{part}/{sort}
  const url = `${process.env.REACT_APP_API_URL}/approval/selects/${style.ssPart}/${style.ssSort}`;

  const formData = JSON.stringify(style);

  logger.log(" UPDATING Style DATA: ", formData);
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      onset: getToken(),
    },
    method: "PUT",
    body: formData,
  })
    .then((response) => {
      logger.log(response);
      if (response) {
        return response.json();
      }
      throw new Error("Error updating style");
    })
    .then((data) => {
      if (data.__type && data.__type === Exceptions.SERIALISATION) {
        throw new Error("Error updating style");
      }
      logger.log(data);
      return true;
      //return imgUploadUrl;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const getStyleMeta = async (sessionCode, styleNumber) => {
  const url = `${process.env.REACT_APP_API_URL}/approval/selects/${sessionCode}/${styleNumber}/meta`;
  const formData = JSON.stringify({});

  logger.log(" GETTING SAMPLE DATA: ", formData);
  return fetch(url, {
    headers: {
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (data && data.Items && data.Items.length) {
        var style = { ...data.Items[0] };
        style.id = style.ssSort;
        style.styleNumber = style.stylenumber;
        // style.assets = [];
        return style;
      } else {
        const error = new Error(ERROR_MESSAGES[ERROR_TYPES.NOT_FOUND]);
        error.type = ERROR_TYPES.NOT_FOUND;
        throw error;
        // throw "No style Found";
      }
    })
    .catch((err) => {
      logger.error("ERROR getting style", err);
      throw err;
    });
};

export const getTaskMeta = async (taskPart, taskSort) => {
  const encodedPart = encodeURIComponent(taskPart);
  const encodedSort = encodeURIComponent(taskSort);
  const url = `${process.env.REACT_APP_API_URL}/approval/post/task/${encodedPart}/${encodedSort}`;
  const formData = JSON.stringify({});

  logger.log(" GETTING SAMPLE DATA: ", formData);
  return fetch(url, {
    headers: {
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (data) {
        var task = new TaskModel({ ...data });
        // task.id = task.taskSort;
        if (task && task.items && task.items.length) {
          task.items.forEach((item) => {
            item.id = item.actionSort;
          });
        }
        return task;
      } else {
        const error = new Error(ERROR_MESSAGES[ERROR_TYPES.NOT_FOUND]);
        error.type = ERROR_TYPES.NOT_FOUND;
        throw error;
        // throw "No style Found";
      }
    })
    .catch((err) => {
      logger.error("ERROR getting style", err);
      throw err;
    });
};

export const updateSession = async (session, token) => {
  const { sessionCode, styleNumber, ...rest } = session;

  const url = `${process.env.REACT_APP_API_URL}/approval/selects/${sessionCode}/${styleNumber}`;

  const formData = JSON.stringify(rest);

  logger.log(" UPDATING Session DATA: ", formData);
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      onset: getToken(),
    },
    method: "PUT",
    body: formData,
  })
    .then((response) => {
      logger.log(response);
      if (response) {
        return response.json();
      }
      throw new Error("Error updating session");
    })
    .then((data) => {
      if (data.__type && data.__type === Exceptions.SERIALISATION) {
        throw new Error("Error updating session");
      }
      logger.log(data);
      return true;
      //return imgUploadUrl;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const getPostProductionTasks = async (id) => {
  const url = `${process.env.REACT_APP_API_URL}/approval/post`;
  const formData = JSON.stringify({});

  logger.log(" GETTING STYLE DATA: ", formData);
  return fetch(url, {
    headers: {
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      // var items = data.Items.map((item, idx) => {
      //   var newItem = {};
      //   newItem = new SampleModel(item);
      //   newItem.id = newItem.styleNumber;
      //   newItem.dept = item.department;
      //   newItem.styleNumber = item.ssSort;
      var items = data.Items.map((item, idx) => {
        // return createTaskModel(item);

        var task = new TaskModel({ ...item });
        task.id = task.taskSort;
        task.tags = task.tags.length ? task.tags.split(",") : [];

        if (task && task.items && task.items.length) {
          task.items.forEach((item) => {
            item.id = item.actionSort;
          });
        }
        return task;
      });

      return items;
    })
    .catch((err) => {
      logger.error("ERROR getting style", err);
      throw err;
    });
};

///////////////
// MARKUPS
///////////////
export const getMarkups = async (id, criteria) => {
  // Encode each path segment separately to handle special characters like #
  const encodedPart = encodeURIComponent(criteria.part);
  const encodedSort = encodeURIComponent(criteria.sort);
  let url = `${process.env.REACT_APP_API_URL}/approval/post/task/${encodedPart}/${encodedSort}/notes`;

  logger.log(" GETTING Captures DATA: ", url);
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error("Error fetching markups");
    })
    .then((data) => {
      logger.log(data);
      const items = data.Items.map((val, idx) => {
        var item = createAnnotationModel(val);
        return item;
      });
      return items;
    })
    .catch((err) => {
      logger.error("ERROR getting markups", err);
      throw err;
    });
};

export const udpateMarkup = async (image, markup, token) => {
  // Encode each path segment separately to handle special characters like #
  const encodedPart = encodeURIComponent(markup.annPart);
  const encodedSort = encodeURIComponent(markup.annSort);
  let url = `${process.env.REACT_APP_API_URL}/approval/post/task/${encodedPart}/${encodedSort}/notes/${markup.id}`;
  logger.log(" UPDATING NOTE DATA: ", url);
  // if (markup.annSort) {
  //     url += `?annSort=${markup.annSort}`;
  // }

  const formData = JSON.stringify({
    payload: markup,
    sequence: image.sequence,
  });

  logger.log(" UPDATING NOTE DATA: ", formData);

  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      onset: getToken(),
    },
    method: "PUT",
    body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      logger.log(data);
      if (data.__type) {
        throw new Error(
          "Sorry we were unable to save the note. Please try again later."
        );
      } else {
        var newItem;

        if (data) {
          var item = data.Attributes;
          const keys = Object.keys(data.Attributes);
          newItem = new AnnotationModel();
          keys.forEach((key, idx) => {
            let tmpKey = key.replace(" ", "");
            tmpKey = key.replace(":", "_");
            // lowercase the first.
            let char = tmpKey.charAt(0).toLowerCase();
            let subStr = tmpKey.substring(1, tmpKey.length);
            const newKey = `${char}${subStr}`;
            newItem[newKey] = item[key]["S"];
          });
        } else {
        }

        // newItem.id = `${newItem.sessionId}|${newItem.sessionSort}`;

        logger.log(newItem);
        //moment(newItem.deadline).format('DD-MM-YYYY');;

        return newItem;
      }
      //return imgUploadUrl;
    })
    .catch((err) => {
      console.error("ERROR updating markup", err);
      throw err;
    });
};

export const removeMarkup = async (id, markup, token) => {
  // Encode each path segment separately to handle special characters like #
  const encodedPart = encodeURIComponent(markup.annPart);
  const encodedSort = encodeURIComponent(markup.annSort);
  let url = `${process.env.REACT_APP_API_URL}/approval/post/task/${encodedPart}/${encodedSort}/notes`;
  const formData = JSON.stringify({
    ...markup,
  });

  logger.log(" DELETING NOTE DATA: ", formData);
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      onset: getToken(),
    },
    method: "POST",
    body: formData,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error("Error removing markup");
    })
    .then((data) => {
      logger.log(data);
      //return imgUploadUrl;
    })
    .catch((err) => {
      console.error("ERROR updating markup", err);
      throw err;
    });
};

const createAnnotationModel = (item) => {
  const keys = Object.keys(item);
  var newItem = new AnnotationModel();
  newItem.annPart = item.annPart;
  newItem.annSort = item.annSort;
  newItem.ts = item.ts;
  newItem.user = item.user;
  newItem.payload = JSON.parse(item.payload).payload;
  newItem.id = newItem.payload.markup.id;
  // keys.forEach((key, idx) => {
  //   let tmpKey = key.replace(" ", "");
  //   tmpKey = key.replace(":", "_");
  //   // lowercase the first.
  //   let char = tmpKey.charAt(0).toLowerCase();
  //   let subStr = tmpKey.substring(1, tmpKey.length);
  //   const newKey = `${char}${subStr}`;
  //   newItem[newKey] = item[key]["S"];
  // });

  // newItem.payload = JSON.parse(newItem.payload);
  logger.log(newItem);

  return newItem;
};

export const updatePostProductionTask = async (task, token) => {
  const encodedPart = encodeURIComponent(task.taskPart);
  const encodedSort = encodeURIComponent(task.taskSort);
  const url = `${process.env.REACT_APP_API_URL}/approval/post/task/${encodedPart}/${encodedSort}`;
  const formData = JSON.stringify(task);
  logger.log(" UPDATING POST PRODUCTION TASK DATA: ", formData);
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      onset: getToken(),
    },
    method: "PUT",
    body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      logger.log(data);

      return true;

    })
    .catch((err) => {
      console.error("ERROR updating markup", err);
      throw err;
    });
};
